import { Component, OnInit } from "@angular/core";
import { PortalAdminService } from "../../services/portal-admin-service/portal-adimin.service";
import { BrandDefinition} from "../../models/brand-definition";
import {SourceSystems} from "../../models/source-system";
import { combineLatest } from "rxjs";

@Component({
    selector: "pa-brand-account",
    templateUrl: "./brand-account.component.html",
    styleUrls: ["./brand-account.component.scss"],
    standalone: false
})
export class BrandAccountComponent implements OnInit {
  brandDefinitions: BrandDefinition[];
  sourceSystems:SourceSystems[];
  isLoadingResults = true;
  isUpdating = false;

  constructor(private portalAdminService: PortalAdminService) {}

  ngOnInit() {
    combineLatest([
      this.portalAdminService.getBrandDefinitions(),
      this.portalAdminService.getSourceSystems(),
    ])
    .subscribe(([brandDefRes,sourcesystems]:[BrandDefinition[],SourceSystems[]])=>{
      this.brandDefinitions = brandDefRes;
      this.sourceSystems = sourcesystems;
      console.log(this.sourceSystems);
      this.isLoadingResults = false;
    });
  }

  updateDefinition(brandDefinition: BrandDefinition, newDefinition: string, newSource:string) {
    this.isUpdating = true;
    brandDefinition.definition = newDefinition;
    brandDefinition.sourceSystem = newSource;
    this.portalAdminService
      .updateBrandDefinitions(brandDefinition)
      .subscribe((brandDefRes) => {
        this.isUpdating = false;
      });
  }
}
